import axiosInstance from "../../utils/axiosInstance";
import { fetch_roles } from "./ApiEndpoint";

export const SENDER="me";
export const LIMIT=10;
export const BOTSLIMIT=12;
export const END_LIVE_SUPPORT="Your live support session has expired. Please feel free to start a new chat if you need any further assistance"

export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const RETRYSWITCHOPTIONS=[
  {id:"support",name:"Support"},
  {id:"agentic",name:"Agentic Ai"}
]

export const TEMPLATEMESSAGELIMIT=[
  {id:"noLimit",name:"noLimit"},
  {id:"monthly",name:"Monthly"},
  {id:"weekly",name:"Weekly"},
  {id:"daily",name:"daily"}
]
export const SLASHSTARTERS=[
  {
    label:"is_support_true",
    name:"Is Live Support Needed"
  },
  {
    label:"is_start_true",
     name:"Can User Use Start Command"
  },
  {
    label:"is_reset_true",
     name:"Can User Use Reset Command"
  },
  {
    label:"is_user_initiate",
    name:"Can User Initiate Chat"
  },
  {
    label:"is_multilingual_true",
    name:"Is Bot Multilingual"
  },
  {
    label:"loop_bot_flow",
    name:"Loop Over Bot Flow When Chat Ends"
  }
]

export const getRoles = async () => {
      try {
        const response = await axiosInstance.get(fetch_roles, { withCredentials: true });
        if (response?.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.error("Failed to fetch roles", error);
      }
    };